import { inject } from '@angular/core';
import {
  CanActivateChildFn,
  Route,
} from '@angular/router';
import { requireAnyPermission } from '../../../auth/permission-guard';
import { PAGE_PERMISSIONS } from '../../../auth/permissions';
import { DashboardMainContentService } from '../../../services/dashboard-main-content';

const use800pxCappedContentWidth: CanActivateChildFn = () => {
  inject(DashboardMainContentService).setMaxWidth('800px');
  return true;
};

export const routes: Route[] = [
  {
    path: 'releasing',
    canActivateChild: [use800pxCappedContentWidth],
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [requireAnyPermission(PAGE_PERMISSIONS.RELEASING)],
        loadComponent: () => import('./releasing').then(({ ReleasingPage }) => ReleasingPage),
      },
      {
        path: 'inventory-expense-orders',
        pathMatch: 'full',
        redirectTo: '/utilities/inventory-expense-orders/release',
      },
    ],
  },
];
